import { Component, OnInit, OnDestroy, AfterContentInit, AfterViewChecked, ViewChild, ElementRef, Output, EventEmitter, Input, HostBinding } from '@angular/core';
import { SplitComponent, SplitAreaDirective } from 'angular-split';
import { Subscription } from 'rxjs';
import { IOutputData } from 'angular-split/lib/interface';
import { on } from 'cluster';
import { DictHandler, SimpleHandler, AnyHandler } from 'src/app/types/@types/sl-v-types';
import { InterruptableTimer } from 'src/app/model/interruptabletimer';
import { EnvService } from 'src/app/env.service';
import { DragNExpandMgr, ExpanderSide } from 'src/app/model/dragnexpandmgr';
import { PointLike } from 'mapbox-gl';


interface ISplitColConfig {
  columns: Array<{
    visible: boolean,
    size: number,
    rows: Array<{
      visible: boolean,
      size: number,
      type: string
    }>
  }>;
  disabled: boolean;
}


@Component({
  selector: 'app-panel-set',
  templateUrl: './panel-set.component.html',
  styleUrls: ['./panel-set.component.scss']
})
export class PanelSetComponent implements AfterContentInit, AfterViewChecked, OnDestroy {
  @ViewChild('mainSplit', { static: true }) mainSplit: SplitComponent;
  @ViewChild('upperSplit', { static: true }) upperSplit: SplitComponent;
  @ViewChild('primaryPanel', { static: true }) primaryPanel: ElementRef;
  @ViewChild('secondaryPanel', { static: true }) secondaryPanel: ElementRef;
  @ViewChild('extendedWorkAreaPanel', { static: true }) extendedWorkAreaPanel: ElementRef;
  @ViewChild('viewPort', { static: true }) viewPort: SplitAreaDirective;
  @Output() changes: EventEmitter<any> = new EventEmitter();
  @Input('st-enabled') stEnabled: 'true' | 'false' = 'true';
  @HostBinding('class.hidden') hidden = true;
  private _primarySize = 340;
  public set primarySize(size: number) {
    this._primarySize = size
  }
  public get primarySize(): number {
    return this._primarySize
  }
  private _secondarySize = 340;
  public set secondarySize(size: number) {
    this._secondarySize = size
  }
  public get secondarySize(): number {
    return this._secondarySize
  }
  private _extendedSize = 30;
  public set extendedSize(size: number) {
    this._extendedSize = size
  }
  public get extendedSize(): number {
    return this._extendedSize
  }
  public panelLoading = true;
  public quarterPanel = 340;
  private oldWidth = 0;
  private isSetup = false;
  private subscriptions: Array<Subscription> = [];
  private sidePanelDragging = false;
  private lastExtendedHeight: number | string;
  private resizeListener: SimpleHandler;
  private gutters: Array<any>;
  private thumbs: Array<DragNExpandMgr>;
  private timer: InterruptableTimer = new InterruptableTimer(250);
  private heights: any;
  private lastOpenedPanel: 'primary' | 'secondary' = 'primary';
  private isSingleHorizontal = false;
  constructor(private domNode: ElementRef, private env: EnvService) { }

  ngAfterContentInit() {
    if (!this.isSetup) {
      this.subscriptions.push(this.upperSplit.gutterClick.subscribe((event: IOutputData) => {
        // this.HandleGutterClick(event.sizes, event.gutterNum);
      }));
      this.subscriptions.push(this.mainSplit.dragEnd.subscribe((event: IOutputData) => {
        this.lastExtendedHeight = ((event.sizes[1] as number) > 5) ? event.sizes[1] : 0;
      }));

      /*this.subscriptions.push(this.mainSplit.gutterClick.subscribe((event: IOutputData) => {

        const size2: number = event.sizes[1] === 0 ? 33.3 : 0;
        const size1: number = 100 - size2;

        this.mainSplit.setVisibleAreaSizes([size1, size2]);
        setTimeout(() => {
          this.UpdatePanels();
        }, 250);
        this.lastExtendedHeight = size2;
      }));*/
      this.domNode.nativeElement.addEventListener('onresize', () => {
        this.onResized();
      });

      this.resizeListener = () => {
        this.onResized();
      };

      window.addEventListener('resize', this.resizeListener);

    }
    window.requestAnimationFrame(() => {
      setTimeout(() => {
        if (this.isSetup === true) {
          return;
        }
        this.SetDefaultWidths();
        this.UpdatePanels();
        this.SetupGutters();
        if (!this.isSetup) {
          this.isSetup = true;
          this.panelLoading = false;
        }
      }, 50);
    })
  }
  SetupGutters() {
    if ($('.panel-set > .as-split-gutter', this.domNode.nativeElement).length === 0) {
      setTimeout(() => { this.SetupGutters(); }, 50);
      return;
    }
    // $('.panel-set > .as-split-gutter', this.domNode.nativeElement).toggleClass('stateful', true);
    // $('.panel-set > .as-split-gutter', this.domNode.nativeElement).toggleClass('req-results-gutter', true);
    const gutters = $('.as-split-gutter');
    this.gutters = [];
    this.thumbs = [];
    const gutterNames = ['left', 'right', 'bottom'];
    gutters.each((index, element) => {

      this.gutters.push(element);
      element.addEventListener('pointerup', () => {
        this.UpdateGutters(false);
      })
      $(element).toggleClass('gutter-' + gutterNames[index]);
      const thumb: DragNExpandMgr = new DragNExpandMgr(element as HTMLDivElement, index, gutterNames[index] as ExpanderSide);
      this.thumbs.push(thumb);
      this.subscriptions.push(thumb.click.subscribe(() => {
        switch (thumb.gutterNum) {
          case 0:
            if (thumb.caretOn === 'left') {
              this.OpenPrimary();
            } else {
              this.ClosePrimary();
            }
            break;
          case 1:
            if (thumb.caretOn === 'right') {
              this.OpenSecondary();
            } else {
              this.CloseSecondary();
            }
            break;
          case 2:
            if (thumb.caretOn === 'down') {
              this.CloseExtended();
            } else {
              this.OpenExtended();
            }

        }
        // this.HandleGutterClick(thumb.gutterNum);
      }));
      $(element).toggleClass('invis', true);
      // $(element).on('mouseup', () => this.UpdatePanels());
    });

  }
  ngAfterViewChecked() {
    const width = $(this.domNode.nativeElement).innerWidth();
    if (this.oldWidth !== width) {
      this.SetDefaultWidths();
    }
    this.oldWidth = width;

  }
  HandleGutterClick(sizes, gutterNum) {
    let size1: any;
    let size2: any;
    let size3: any;
    const panelsWidth = $(this.domNode.nativeElement).innerWidth();
    const quarterPanel = 340;
    const halfPanel = panelsWidth * .5 - 11;
    let defaultWidth = quarterPanel;
    if ($(document.body).hasClass('sm') || $(document.body).hasClass('xs')) {
      defaultWidth = halfPanel;
    }
    if (this.isSingleHorizontal) defaultWidth = $(this.domNode.nativeElement).innerWidth();
    switch (gutterNum) {
      case 1:
        size1 = (sizes[0] === 0) ? defaultWidth : 0;
        size3 = sizes[2] as number;
        size2 = 'calc(' + size1 + ' - ' + size1 + 'px - ' + size3 + 'px)';
        this.upperSplit.setVisibleAreaSizes([size1, size2, size3]);
        break;
      case 2:
        size3 = (sizes[2] === 0) ? defaultWidth : 0;
        size1 = sizes[0] as number;
        size2 = 'calc(' + size1 + ' - ' + size1 + 'px - ' + size3 + 'px)';
        this.upperSplit.setVisibleAreaSizes([size1 as any, size2 as any, size3 as any] as any);
        break;

    }
    setTimeout(() => {
      // $('.panel.primary-panel').toggleClass('invis', size1 === 0);
      // $('.panel.secondary-panel').toggleClass('invis', size3 === 0);
      this.UpdatePanels();
    }, 225);
    this.UpdateThumbs();

  }
  onResized() {
    this.SetDefaultWidths();
    this.UpdatePanels('auto', 'auto', () => {
      this.UpdatePanels('auto', 'auto');
    });

  }
  UpdatePanelVis(sizes: Array<any>) {

    // $('.panel.primary-panel').toggleClass('invis', sizes[0] === 0);
    // $('.panel.secondary-panel').toggleClass('invis', sizes[2] === 0);

    // this.UpdatePanelVis('middle');


  }
  GetVisibleArea(): { primary: number, secondary: number, extended: number } {
    const sizes = this.upperSplit.getVisibleAreaSizes();
    if (this.domNode.nativeElement.getClientRects()?.length < 1) {
      return { primary: 0, secondary: 0, extended: 0 }

    }
    const width = this.domNode.nativeElement.getClientRects()[0].width;
    const height = this.domNode.nativeElement.getClientRects()[0].height;
    const primaryWidth = this.primaryPanel.nativeElement.getClientRects()[0].width;
    const secondaryWidth = this.secondaryPanel.nativeElement.getClientRects()[0].width;
    const extendedHeight = this.extendedWorkAreaPanel.nativeElement.getClientRects()[0].height;
    return { primary: primaryWidth, secondary: secondaryWidth, extended: extendedHeight }

  }
  SetDefaultWidths() {
    let size1: number;
    let size2: string;
    let size3: number;
    const panelsWidth = $(this.domNode.nativeElement).innerWidth();

    const quarterPanel = 340;
    const halfPanel = panelsWidth * .5 - 11;
    let defaultWidth = quarterPanel;
    if (panelsWidth <= 576) {
      defaultWidth = halfPanel;
    }
    const sizes = this.upperSplit.getVisibleAreaSizes();

    size1 = (sizes[0] === 0) ? 0 : defaultWidth;
    size3 = (sizes[2] === 0) ? 0 : defaultWidth;
    size2 = '*';
    this.upperSplit.setVisibleAreaSizes([size1 as any, size2 as any, size3 as any] as any);
    setTimeout(() => {
      $('.panel.primary-panel').toggleClass('invis', size1 === 0);
      $('.panel.secondary-panel').toggleClass('invis', size3 === 0);
    }, 225);

  }
  private wasSquishy = false;

  UpdatePanels(
    primary: number | 'auto' = 'auto', secondary: number | 'auto' = 'auto',
    ready: AnyHandler = null, noEmit: boolean = false) {

    if (!!this.gutters) {
      // $(this.gutters[0]).toggleClass('invis', true);
      // $(this.gutters[1]).toggleClass('invis', true);
    }
    setTimeout(() => {

      let isSquishyThirdsies = $('body').hasClass('gt-sm') === false;
      if (isSquishyThirdsies === true) {
        this.wasSquishy = true;
        if ($('body').hasClass('is-horizontal') === true) {
          isSquishyThirdsies = false;
        }
      }
      if (this.wasSquishy && !isSquishyThirdsies) {
        this.wasSquishy = false;
        this.UpdateSinglePanels();
      }
      const myHeight = this.domNode.nativeElement.clientHeight;
      const extendedHeight = this.extendedWorkAreaPanel.nativeElement.clientHeight;
      let maxPanelHeight = myHeight - extendedHeight;
      if (isSquishyThirdsies && this.stEnabled === 'true') {
        maxPanelHeight = maxPanelHeight / 2;
      }
      document.documentElement.style.setProperty('--panels-main-height', maxPanelHeight + 'px');
      document.documentElement.style.setProperty('--panels-total-height', myHeight + 'px');
      if (!!this.gutters) {
        document.documentElement.style.setProperty('--gutters-left-thickness', this.gutters[0].clientHeight + 'px');
        document.documentElement.style.setProperty('--gutters-right-thickness', this.gutters[1].clientHeight + 'px');
      }
      const innerSecondaryPanel = $('div.secondary-panel app-view-stack')[0];

      let secondaryHeight = Math.min(Math.max($(innerSecondaryPanel).height(), 24), maxPanelHeight); // this.secondaryPanel.nativeElement.clientHeight;
      // if (secondaryHeight > 38) {
      const attViewActive = $('app-view-stack-view.attribute-view.active',
        this.secondaryPanel.nativeElement.children[0].children[0]).length === 1;
      const attViewExpanded = $('.attribute-view.is-expanded',
        this.secondaryPanel.nativeElement.children[0].children[0]).length === 1;
      const legendViewActive = $('app-view-stack-view.legend-view.active',
        this.secondaryPanel.nativeElement.children[0].children[0]).length === 1;
      const captureViewActive = $('app-view-stack-view.image-caputure-view.active',
        this.secondaryPanel.nativeElement.children[0].children[0]).length === 1;
      if (attViewActive || legendViewActive || captureViewActive) {
        secondaryHeight = Math.max(24, secondaryHeight);
      }

      if (this.stEnabled === 'true') {
        if (attViewActive && attViewExpanded) {
          secondaryHeight = maxPanelHeight;
        } else if (!legendViewActive && !captureViewActive) {
          secondaryHeight = 0;
        } else {
          secondaryHeight = Math.min(secondaryHeight, maxPanelHeight);
        }
      } else {
        document.documentElement.style.setProperty('--panels-secondary-height', Math.min(secondaryHeight, maxPanelHeight) + 'px');
      }

      // }
      const primaryHeight = Math.min($('div.primary-panel app-view-stack').height(), maxPanelHeight);
      //$(this.primaryPanel.nativeElement).css({'height': primaryHeight + 'px !important'});
      (this.primaryPanel.nativeElement as HTMLDivElement).style.setProperty('height', primaryHeight + 'px', 'important');
      // $(this.secondaryPanel.nativeElement).css('height', secondaryHeight + 'px');

      $($('.upper-split .as-split-gutter')[0]).css('height', primaryHeight + 'px');
      $($('.upper-split .as-split-gutter')[0]).css('min-height', primaryHeight + 'px');


      // $($('.upper-split .as-split-gutter')[1]).css('height', secondaryHeight + 'px');

      $('.panel-set', this.domNode.nativeElement).toggleClass('extended-view-open', $('.extended-panel').height() > 3);
      document.documentElement.style.setProperty('--panels-primary-height', Math.min(primaryHeight, maxPanelHeight) + 'px');



      if (!!this.gutters) {
        $(this.gutters[0]).height(primaryHeight);
        $(this.gutters[0]).css('height', primaryHeight + 'px');
        $(this.gutters[0]).css('min-height', primaryHeight + 'px');
        $(this.gutters[0]).css('display', (primaryHeight === 0) ? 'none' : 'flex');

        $(this.gutters[1]).height(secondaryHeight);
        $(this.gutters[1]).css('height', secondaryHeight + 'px');
        $(this.gutters[1]).css('min-height', secondaryHeight + 'px');
        $(this.gutters[1]).css('display', (secondaryHeight === 0) ? 'none' : 'flex');
      }

      this.heights = {
        primary: primaryHeight,
        secondary: secondaryHeight,
        extended: extendedHeight,
        panelMax: maxPanelHeight
      };
      if (!!this.gutters) {
        for (const gutter of this.gutters) {
          $(gutter).toggleClass('invis', false);
        }
      }
      $(this.primaryPanel.nativeElement).toggleClass('invis', false);
      $(this.secondaryPanel.nativeElement).toggleClass('invis', false);
      if (ready !== null) {
        ready(this);
      }
      if (noEmit === false) {
        this.changes.emit(this.heights);
      }
      if (this.gutters?.length > 0) {
        this.gutters[0].classList.toggle('hidden', (maxPanelHeight < 38) || this.isSingleHorizontal);
        this.gutters[1].classList.toggle('hidden', (maxPanelHeight < 38) || this.isSingleHorizontal);
      }
      window.requestAnimationFrame(() => {
        this.UpdateThumbs();
      })
      this.UpdateSinglePanels();
      this.hidden = false;
    }, 1);

  }
  UpdateGutters(noEmit = true) {
    this.UpdatePanels('auto', 'auto', null, noEmit);
    /* setTimeout(() => {
      if (this.gutters) {
        if (!!this.heights) {
          $(this.gutters[0]).height(this.heights.primaryHeight);
          $(this.gutters[1]).height(this.heights.secondaryHeight);
        }
      }
    }, 2000);
    */

  }
  ToggleClass(className: string, onOff: boolean = null) {
    if (onOff === null) {
      $(this.domNode.nativeElement).toggleClass(className);
      return this.domNode.nativeElement.classList.contains(className);

    }
    $(this.domNode.nativeElement).toggleClass(className);
    return this.domNode.nativeElement.classList.contains(className);

  }
  TogglePrimary() {
    const sizes = this.upperSplit.getVisibleAreaSizes();
    if (sizes[0] === 0) {
      this.OpenPrimary();
    } else {
      this.ClosePrimary();
    }
    this.UpdateThumbs();

  }
  OpenPrimary(autoUpdate: boolean = true) {
    const sizes = this.upperSplit.getVisibleAreaSizes();
    sizes[0] = this.quarterPanel;
    this.upperSplit.setVisibleAreaSizes(sizes);
    this.UpdateThumbs();
    this.lastOpenedPanel = 'primary';

    this.primaryPanel.nativeElement.classList.toggle('hidden', false);
    window.requestAnimationFrame(() => {
      this.UpdatePanels();
      if (autoUpdate === true) {
        this.UpdateSinglePanels();
      }
    });
  }
  ClosePrimary() {
    const sizes = this.upperSplit.getVisibleAreaSizes();
    sizes[0] = 0;
    this.upperSplit.setVisibleAreaSizes(sizes);
    this.UpdateThumbs();
    this.primaryPanel.nativeElement.classList.toggle('hidden', this.isSingleHorizontal);
    window.requestAnimationFrame(() => {
      this.UpdatePanels();
    });
  }
  ToggleSecondary() {
    const sizes = this.upperSplit.getVisibleAreaSizes();
    if (sizes[2] === 0) {
      this.OpenSecondary();
    } else {
      this.CloseSecondary();
    }
    this.UpdateThumbs();


  }
  OpenSecondary(autoUpdate: boolean = false) {
    const sizes = this.upperSplit.getVisibleAreaSizes();
    sizes[2] = this.quarterPanel;
    this.upperSplit.setVisibleAreaSizes(sizes);
    this.UpdateThumbs();
    this.lastOpenedPanel = 'secondary';
    this.secondaryPanel.nativeElement.classList.toggle('hidden', false);
    window.requestAnimationFrame(() => {
      this.UpdatePanels();
      if (autoUpdate === true) {
        this.UpdateSinglePanels();
      }

    });
  }
  CloseSecondary(autoUpdate: boolean = true) {
    const sizes = this.upperSplit.getVisibleAreaSizes();
    sizes[2] = 0;
    this.upperSplit.setVisibleAreaSizes(sizes);
    this.UpdateThumbs();
    if (autoUpdate === true) {
      if (this.lastOpenedPanel === 'secondary') {
        this.lastOpenedPanel = 'primary';
      }
    }
    this.secondaryPanel.nativeElement.classList.toggle('hidden', this.isSingleHorizontal);
    window.requestAnimationFrame(() => {
      this.UpdatePanels();
    });
  }
  ToggleExtended() {
    const sizes = this.mainSplit.getVisibleAreaSizes();
    if (sizes[1] === 0) {
      this.OpenExtended();
    } else {
      this.CloseExtended();
    }
    this.UpdateThumbs();

  }
  OpenExtended() {
    const myHeight = this.domNode.nativeElement.clientHeight;
    if (this.lastExtendedHeight <= myHeight) {
      this.lastExtendedHeight = 33.3;
    }
    const size2: number | string = (!!this.lastExtendedHeight) ? this.lastExtendedHeight : 33.3;
    const size1: number = 100 - (size2 as number);
    this.mainSplit.setVisibleAreaSizes([size1 as any, size2 as any]);
    requestAnimationFrame(() => {
      this.UpdatePanels();
    });
    $('.panel-set', this.domNode.nativeElement).toggleClass('extended-view-open', true);
    this.UpdateThumbs();

  }
  CloseExtended() {

    this.mainSplit.setVisibleAreaSizes([100, 0]);
    this.timer.Start(() => {
      this.UpdatePanels();
    }, 250);
    $('.panel-set', this.domNode.nativeElement).toggleClass('extended-view-open', false);
    this.UpdateThumbs();

  }
  UpdateThumbs() {
    if (!this.thumbs) return;
    for (const thumb of this.thumbs) {
      thumb.Refresh();
    }
  }
  ngOnDestroy(): void {
    if (!!this.subscriptions) {
      for (const sub of this.subscriptions) {
        sub.unsubscribe();
      }
    }
    window.removeEventListener('resize', this.resizeListener);
  }
  SetSinglePanelMode(isSinglePanel: boolean) {
    if (!this.domNode || !this.domNode.nativeElement || !this.gutters || this.gutters.length < 3) {
      window.requestAnimationFrame(() => {
        this.SetSinglePanelMode(isSinglePanel);
      })
      return;
    }
    this.domNode.nativeElement.classList.toggle('single-panel-mode', isSinglePanel);
    this.isSingleHorizontal = isSinglePanel;
    this.gutters[0].classList.toggle('hidden', isSinglePanel);
    this.gutters[1].classList.toggle('hidden', isSinglePanel);
    this.UpdatePanels();

  }
  UpdateSinglePanels() {
    if (this.isSingleHorizontal) {

      switch (this.lastOpenedPanel) {
        case 'primary':
          if (!(this.secondaryPanel.nativeElement.classList.contains('hidden'))) {
            this.CloseSecondary();
          }
          if (this.primaryPanel.nativeElement.classList.contains('hidden')) {
            this.OpenPrimary(false);
          }
          break;
        case 'secondary':
          if (!(this.primaryPanel.nativeElement.classList.contains('hidden'))) {
            this.ClosePrimary();
          }
          if (this.secondaryPanel.nativeElement.classList.contains('hidden')) {
            this.OpenSecondary(false);
          }

          break;
      }
    } else {
      if ((this.primaryPanel.nativeElement.classList.contains('hidden'))) {
        this.OpenPrimary();
      }
      if ((this.secondaryPanel.nativeElement.classList.contains('hidden'))) {
        this.OpenSecondary();
      }
    }
  }

}
